// extracted by mini-css-extract-plugin
export default {"container":"styles_container__I6i4l","inner":"styles_inner__fiOOc","contentInput":"styles_contentInput__ONC4a","submitButton":"styles_submitButton__1JEQI"};